import { takeLatest } from 'redux-saga/effects';
import {
  getEmployeeListSuccess, getEmployeeListFail,
  getEmployeeDetailsSuccess, getEmployeeDetailsFail,
  getEmployeeScheduleListSuccess, getEmployeeScheduleListFail,
  getEmployeeScheduleDetailsSuccess, getEmployeeScheduleDetailsFail,
  getEmployeeSettingListSuccess, getEmployeeSettingListFail,
  getEmployeeSettingDetailsSuccess, getEmployeeSettingDetailsFail,
  getEmployeeStatSuccess, getEmployeeStatFail,
} from './employeeState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/workforce/employees');
const timekeepingService = createCrudService('api/v1/timekeeping/employees');
const systemService = createCrudService('api/v1/system/employees');
const redirectData = {route:'/console/employees', mode: 'list', recordId:0 };
const modelName = 'Employee';
const modelId = 'emp_id';

function* getEmployeeList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getEmployeeListSuccess, 
		getEmployeeListFail, null, null, LOADING_MSG);
}

function* getEmployeeDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getEmployeeDetailsSuccess, 
		getEmployeeDetailsFail, null, null, LOADING_MSG);		
}

function* doEmployeeCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getEmployeeDetailsSuccess, 
		getEmployeeDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'},
		SAVING_MSG);
}

function* doEmployeeUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getEmployeeDetailsSuccess, 
		getEmployeeDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doEmployeeDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getEmployeeDetailsSuccess, 
		getEmployeeDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

// for schedule
function* getEmployeeScheduleList(data) {
	const { employeeId, ... params } = data.payload;
	const childEndpoint = `${employeeId}/employee-schedules`;
	yield doCrudCall(
		() => timekeepingService.getList(params, childEndpoint), 
		getEmployeeScheduleListSuccess, 
		getEmployeeScheduleListFail, null, null, LOADING_MSG);
}

function* getEmployeeScheduleDetails(data) {
	
	const { employeeId, scheduleId } = data.payload;
	const childEndpoint = `${employeeId}/employee-schedules`;
	yield doCrudCall(
		() => timekeepingService.getDetails(scheduleId, childEndpoint), 
		getEmployeeScheduleDetailsSuccess, 
		getEmployeeScheduleDetailsFail, null, null, LOADING_MSG);		
}

function* doEmployeeScheduleCreate(data){
	const esd_employee_id = data.payload.esd_employee_id;
	const childEndpoint = `${esd_employee_id}/employee-schedules`;
	yield doCrudCall(
		() => timekeepingService.doCreate(data.payload, childEndpoint), 
		getEmployeeScheduleDetailsSuccess, 
		getEmployeeScheduleDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'},
		SAVING_MSG);
}

function* doEmployeeScheduleUpdate(data){
	const { employeeId, esd_id } = data.payload
	const childEndpoint = `${employeeId}/employee-schedules`;
	yield doCrudCall(
		() => timekeepingService.doUpdate(esd_id, data.payload, childEndpoint), 
		getEmployeeScheduleDetailsSuccess, 
		getEmployeeScheduleDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doEmployeeScheduleDelete(data){
	const { esd_employee_id, esd_id  } = data.payload;
	const childEndpoint = `${esd_employee_id}/employee-schedules`;
	yield doCrudCall(
		() => timekeepingService.doDelete(esd_id, childEndpoint), 
		getEmployeeScheduleDetailsSuccess, 
		getEmployeeScheduleDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: "reload"},
		DELETING_MSG);	
}

// for setting
function* getEmployeeSettingList(data) {
	const {parentId, ... params } = data.payload;
	const childEndpoint = `${parentId}/settings`;
	yield doCrudCall(
		() => systemService.getList(params, childEndpoint), 
		getEmployeeSettingListSuccess, 
		getEmployeeSettingListFail, null, null, LOADING_MSG);
}

function* getEmployeeSettingDetails(data) {
	const { employeeId, set_id} = data.payload;
	const childEndpoint = `${employeeId}/settings`;
	yield doCrudCall(
		() => systemService.getDetails(set_id, childEndpoint), 
		getEmployeeSettingDetailsSuccess, 
		getEmployeeSettingDetailsFail, null, null, LOADING_MSG);		
}

function* getEmployeeStat(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('statistics/employee-stats', data.payload), 
		getEmployeeStatSuccess, 
		getEmployeeStatFail, null, null, LOADING_MSG);
}

function* doEmployeeSettingUpdate(data){
	const { parentId, settingId } = data.payload
	const childEndpoint = `${parentId}/settings`;
	yield doCrudCall(
		() => systemService.doUpdate(settingId, data.payload, childEndpoint), 
		getEmployeeSettingDetailsSuccess, 
		getEmployeeSettingDetailsFail,
		updateRecordSuccess(modelName),
		null,
		UPDATING_MSG);
}

function* employeeSaga() {
  yield takeLatest('employee/getEmployeeList', getEmployeeList);
  yield takeLatest('employee/getEmployeeDetails', getEmployeeDetails);
  yield takeLatest('employee/doEmployeeCreate', doEmployeeCreate);
  yield takeLatest('employee/doEmployeeUpdate', doEmployeeUpdate);
  yield takeLatest('employee/doEmployeeDelete', doEmployeeDelete);
  yield takeLatest('employee/getEmployeeScheduleList', getEmployeeScheduleList);
  yield takeLatest('employee/getEmployeeScheduleDetails', getEmployeeScheduleDetails);
  yield takeLatest('employee/doEmployeeScheduleCreate', doEmployeeScheduleCreate);
  yield takeLatest('employee/doEmployeeScheduleUpdate', doEmployeeScheduleUpdate);
  yield takeLatest('employee/doEmployeeScheduleDelete', doEmployeeScheduleDelete);
  yield takeLatest('employee/getEmployeeSettingList', getEmployeeSettingList);
  yield takeLatest('employee/getEmployeeSettingDetails', getEmployeeSettingDetails);
  yield takeLatest('employee/doEmployeeSettingUpdate', doEmployeeSettingUpdate);
  yield takeLatest('employee/getEmployeeStat', getEmployeeStat);
}

export default employeeSaga;
